/* eslint-disable require-jsdoc,flowtype/require-parameter-type,complexity,max-statements,array-callback-return */
/* eslint-disable camelcase */
import {createSelector} from 'reselect';

import type {
    ProductType,
    LensColorItemType,
    LensColorType,
    ColorsSizesType,
} from 'constants/flow/flowTypesProduct';
import type {ApplicationStoreType} from 'constants/flow/flowTypes';

import {getSimples} from './product';
import {pathOr, map, prop, compose, join, values} from 'ramda';

/**
 * Get active selected by default color for sunglasses
 * @param {ApplicationStoreType} store application
 * @returns {{group: LensColorType, color: LensColorItemType}} result of finding selected color
 */
export function getSelectedColorByDefault(
    store: ApplicationStoreType,
): {group: LensColorType, color: LensColorItemType} {
    const {colors} = store.wizard;
    let selectedColor = {group: {}, color: {}};
    if (colors) {
        Object.keys(colors.groups).forEach((value: string) => {
            colors.groups[value].colors.forEach((color: Array<LensColorItemType>) => {
                if (Number(colors.checked) === color.id) {
                    selectedColor = {group: colors.groups[value], color};
                }
            });
        });
    }

    return selectedColor;
}

export const getColorsSizesProduct = createSelector(
    getSimples,
    (products: ProductType): ColorsSizesType => {
        if (products === false) return [];
        const colorList = {};

        Object.values(products).map((item: {}): {} => {
            const size = pathOr('', ['frame', 'size', 'shortLabel'], item);
            const color = pathOr('', ['color', 'label'], item);
            const value = pathOr('', ['frame', 'size', 'label'], item);
            const lens_feature_value = compose(
                join(''),
                map(prop('label')),
                values,
                prop('lensFeatures'),
            )(item);

            const {id, url} = item;

            if (colorList[color]) {
                colorList[color].sizes.push({
                    size,
                    id,
                    url,
                    value,
                });
            } else {
                colorList[color] = {
                    id,
                    color,
                    image: pathOr('', ['color', 'src'], item),
                    sizes: [],
                    url,
                    quantity: pathOr(0, ['stock', 'qty'], item),
                    lens_feature_value,
                };
                colorList[color].sizes.push({
                    size,
                    id,
                    url,
                    value,
                });
            }
        });

        return colorList;
    },
);
